/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_AdminDashboardGrantList } from '../models/PagedResultDto_AdminDashboardGrantList';
import type { PagedResultDto_OptionAwardListDto } from '../models/PagedResultDto_OptionAwardListDto';
import type { PagedResultDto_UpcomingVestingGrantsDto } from '../models/PagedResultDto_UpcomingVestingGrantsDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_ExportOptionAwardDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_ExportOptionAwardDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardAddUpdateResponseDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardAddUpdateResponseDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobRequestDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobRequestDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardCreationResponseDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardCreationResponseDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportDataDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportDataDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportTemplateParseDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportTemplateParseDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardNumberDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardNumberDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardVestingScheduleDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardVestingScheduleDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionDocumentDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionDocumentDto';
import type { Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_GenericBackgroundValidationResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_GenericBackgroundValidationResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView';
import type { Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetGrantDetailsDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetGrantDetailsDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO';
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OptionAwardService {

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardGrants(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/grants',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardPlanTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/plan-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardVestingSchedule(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetValuesDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/vesting-schedule',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAwardStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-award-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardEmployeeStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/employee-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAcceptances(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-acceptances',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardEmployeeIds(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetParticipantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/employee-ids',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_GetGrantDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardGrantDetails(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_GetGrantDetailsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/grant-details',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param approvalStatusIds 
     * @param createdFromDate 
     * @param createdToDate 
     * @param grantFromDate 
     * @param grantToDate 
     * @param employeeStatuses 
     * @param optionStatus 
     * @param optionAcceptance 
     * @param isEarlyExercisable 
     * @param approvedFromDate 
     * @param approvedToDate 
     * @param publishFromDate 
     * @param publishToDate 
     * @param expirationFromDate 
     * @param expirationToDate 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_OptionAwardListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAwardList(
approvalStatusIds?: Array<number>,
createdFromDate?: string,
createdToDate?: string,
grantFromDate?: string,
grantToDate?: string,
employeeStatuses?: Array<number>,
optionStatus?: number,
optionAcceptance?: number,
isEarlyExercisable?: boolean,
approvedFromDate?: string,
approvedToDate?: string,
publishFromDate?: string,
publishToDate?: string,
expirationFromDate?: string,
expirationToDate?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_OptionAwardListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-award-list',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'CreatedFromDate': createdFromDate,
                'CreatedToDate': createdToDate,
                'GrantFromDate': grantFromDate,
                'GrantToDate': grantToDate,
                'EmployeeStatuses': employeeStatuses,
                'OptionStatus': optionStatus,
                'OptionAcceptance': optionAcceptance,
                'IsEarlyExercisable': isEarlyExercisable,
                'ApprovedFromDate': approvedFromDate,
                'ApprovedToDate': approvedToDate,
                'PublishFromDate': publishFromDate,
                'PublishToDate': publishToDate,
                'ExpirationFromDate': expirationFromDate,
                'ExpirationToDate': expirationToDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportDataDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAwardForUpdateById(
awardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportDataDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-award-for-update-by-id/{awardId}',
            path: {
                'awardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardNumberDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAwardNumbers(
optionAwardId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardNumberDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-award-numbers/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromdate 
     * @param todate 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardFileNamesByDate(
fromdate?: string,
todate?: string,
): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/file-names-by-date',
            query: {
                'fromdate': fromdate,
                'todate': todate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_UpcomingVestingGrantsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardUpcomingVestingGrants(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_UpcomingVestingGrantsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/upcoming-vesting-grants',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardUpcomingGrantList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrants>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/upcoming-grant-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingDate 
     * @param grantId 
     * @returns Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardAdminDashboardGrantView(
vestingDate?: string,
grantId?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/admin-dashboard-grant-view',
            query: {
                'VestingDate': vestingDate,
                'GrantId': grantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param vestingDate 
     * @param grantId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_AdminDashboardGrantList OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardAdminDashboardGrantList(
vestingDate?: string,
grantId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_AdminDashboardGrantList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/admin-dashboard-grant-list',
            query: {
                'VestingDate': vestingDate,
                'GrantId': grantId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardBulkImportStatus(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/bulk-import-status/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardValidateBulkOptionAwards(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/validate-bulk-option-awards',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppOptionAwardOptionAwardById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDtoWithListMessage> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/option-award/option-award-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardIds 
     * @returns Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppOptionAwardOptionAwardLists(
awardIds?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_DeleteAwardResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/option-award/option-award-lists',
            query: {
                'AwardIds': awardIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardCancelOptionAwardById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/cancel-option-award-by-id/{Id}',
            path: {
                'Id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardPublishOptionAward(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/publish-option-award',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardSendParticipantsSignUpLinks(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/send-participants-sign-up-links',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAwardOverview(
optionAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-award-overview/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardVestingScheduleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAwardVestingSchedule(
optionAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardVestingScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-award-vesting-schedule/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionDocumentDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAwardDocuments(
optionAwardId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionAward_OptionDocumentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-award-documents/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardDownloadDocument(
requestBody?: Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobRequestDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/download-document',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardDownloadOptionAwardSample(): CancelablePromise<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardSampleFileBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/download-option-award-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardGetExportOptionAward(
requestBody?: Wealthlane_AwardService_Dtos_OptionAward_ExportOptionAwardDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/get-export-option-award',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardExportAdminDashboardGrantList(
requestBody?: Wealthlane_AwardService_Dtos_RSUAward_AdminDashboardGrantViewRequestDto,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/export-admin-dashboard-grant-list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardReCalculateIsoValues(
participantId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/re-calculate-iso-values/{participantId}',
            path: {
                'participantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardOptionAwardDetailByOptionAwardId(
optionAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award/option-award-detail-by-option-award-id/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardCreationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardOptionsAwards(
requestBody?: Array<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportTemplateParseDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardCreationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/options-awards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardCreationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardEditOptionsAwards(
requestBody?: Array<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardImportTemplateParseDto>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardCreationResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/edit-options-awards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param isoSortingTypeId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardChangeIsosortingType(
isoSortingTypeId: number,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/change-isosorting-type/{isoSortingTypeId}',
            path: {
                'isoSortingTypeId': isoSortingTypeId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_GenericBackgroundValidationResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardModifyIsoValues(
requestBody?: Array<Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_GenericBackgroundValidationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/modify-iso-values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardAddUpdateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardOptionAwardRefactTest(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardAddUpdateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/option-award-refact-test',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardImportTest(
formData?: {
File?: Blob;
},
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award/import-test',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
